<template>
  <div style="padding: 10px;">
    <div class="tree-win">
      <div class="tree-win-left">
        <erp-tree-status-common height="80vh" @node-click="nodeClick"></erp-tree-status-common>
      </div>
      <div class="tree-win-rigth">
        <div>
          <el-button :disabled="list.length===0" type="success" @click="saveIndex">保存排序</el-button>
          <el-button size="mini" type="primary" @click="getHouseNodeExcel">导出</el-button>
          <el-button size="mini" type="primary" @click="putHouseNodeExcel">导入</el-button>
        </div>
        <div class="tree-win-rigth-header">拖拽排序即可，也可以点击“↑”代表向上，“↓”代表向下。</div>
        <div class="tree-win-rigth-flex">
          <div class="tree-win-rigth-content">
            <draggable animation="150" v-model="list" @start="draggableStart" @end="draggableEnd">
              <div class="theme-content-item" v-for="(element,index) in list" :key="element.id">
                <div>
                  <span v-if="element.type==='room'" class="fangtai" :class="roomStatusIoc(element.room_status_ids)"></span>
                  {{element.house_name}}
                </div>
                <div>
                  <el-button size="mini" icon="el-icon-top" @click="onSort(element,index,-1)" circle></el-button>
                  <el-button size="mini" icon="el-icon-bottom" @click="onSort(element,index,1)" circle></el-button>
                </div>
              </div>
            </draggable>
          </div>
          <div class="tree-win-rigth-flex-msgbox">
            <p style="margin-top: 10px;"><span style="font-size:14px;"><strong>项目房产结构排序：</strong></span></p>
            <p style="margin-top: 10px;"><span style="font-size:14px;">1、系统提供两种方式的排序机制，一种在线调整，另一种是通过Excel批量调整。</span></p>
            <p style="margin-top: 10px;"><span style="font-size:14px;">2、在线调整：点击左侧房产树，等待拖动窗口出现房产拖动或者调整，确定排序后点击保存即可！</span></p>
            <p style="margin-top: 10px;"><span style="font-size:14px;">3、Excel批量调整：点击左侧房产树，再点击导出，得到Excel文件后通过办公软件可以对房产路径或者房产名称进行排序或者其他排序调整，确定没问题后保存文件导入系统，刷新页面即可。</span></p>
            <p style="margin-top: 10px;"><span style="font-size:14px;">备注：<span style="color:#e74c3c">Excel禁止修改里面的数据，只可以排序，排序需要时长较长，耐心等待，如果保存后过5分钟后不见反应，请联系技术人员。</span></span></p>
          </div>
        </div>

<!--        <div style="text-align: center;width: 100%;padding: 10px 0;">-->
<!--          -->
<!--        </div>-->
      </div>
    </div>
  </div>

</template>

<script>
  import draggable from 'vuedraggable'
  import ErpTreeStatusCommon from "./erp-tree-status-common";
  import Http from "../Butler/common/Http";

  export default {
    name: 'ErpTreeUpdateStatus',
    components: {ErpTreeStatusCommon, draggable},
    data() {
      return {
        pid:"",
        list:[],
        // dialogVisible:false,
        treeObj:{}
      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      show(){
        // this.dialogVisible=true;
      },
      nodeClick(data) {

        const _this = this;
        const region_id = data.id;
        this.treeObj=data;
        if(region_id === '' || region_id === undefined){
          return false;
        }
        console.log(data)
        //加载
        let data_set=data.tree.find(ret=>ret.id===data.id)
        data_set.pindex_id=data.tree[0].pindex_id
        data_set.region_id = region_id;
        this.$myhttp.post('admin/common/getbindingArrs',data_set,{
          'Content-Type': 'application/json'
        }).then(ret=>{ // 异步执行成功后
          _this.list=ret.data
        });
      },
      draggableStart(e){
        // console.log(e)
      },
      draggableEnd(e){
        // var that=this;
        // let mdData=that.theme_list[newIndex];
        // that.theme_list[newIndex]=that.theme_list[oldIndex]
        // console.log(JSON.parse(JSON.stringify(this.theme_list)))
      },
      roomStatusIoc(ids){
        // 1	空置	空	1	1	开发商未出售的房子
        // 2	未领	锁	2	1	已售、未交楼（出售、入伙）
        // 3	空关	关	4	1	已售、已交楼、未装修、未入住
        // 4	装修	装	8	1	在装修
        // 5	入住	绿人	16	1	已入住
        // 6	出租	租	32	1	已出租
        // 7	停用		64	1
        // 8	其他		128	0
        //chuzu,kongguan,kongzhi,ruzhu,zhuangxiu,tingyong,weiling

        let icons=['kongzhi','weiling','kongguan','zhuangxiu','ruzhu','chuzu','tingyong','qita']

        try {
          ids.findIndex(',')!==-1&&(ids=ids.split(','),ids=ids[0]);
        }catch (e) {
          console.log(ids)
        }

        return 'fangtai_'+icons[ids-1]
      },
      onSort(element,index,type=1){
        const that=this;
        let _temp_1=that.list[index];
        let _temp_2=null;
        if(type>0){
          _temp_2=that.list[index+1];
          that.list[index]=_temp_2;
          that.list[index+1]=_temp_1;
        }else {
          _temp_2=that.list[index-1];
          that.list[index]=_temp_2;
          that.list[index-1]=_temp_1;
        }
        _temp_2=null;
        _temp_1=null;
        that.$forceUpdate();
      },
      saveIndex(){
        const that=this;
        console.log(that.list)
        let form_list=[];
        that.list.map((ret,index)=>{
          form_list.push({parent_id:ret.parent_id,house_id:ret.house_id,weight:index})
        })

        ERP.postRequest({
          url:"admin/ProjectHouse/saveListData",
          data:{
            tree_list_str:JSON.stringify(form_list)
          },
        },ret=>{
          if(ret.code){
            that.$message.success(ret.msg||"排序成功")
          }else {
            that.$message.error(ret.msg||"排序失败")
          }
        })

      },
      getHouseNodeExcel(){
        const that=this;
        if(!that.treeObj.id){
          that.$message.error('请选择左侧节点')
          return false;
        }
        ERP.postRequest({
          url:"admin/ProjectHouse/getHouseNodeExcel",
          data:{
            parent_id:that.treeObj.level!==1?that.treeObj.id:0,
            project_id:that.treeObj.level===1?that.treeObj.id:0,
          },
        },ret=>{
          if(ret.code){
            window.open(__HTTP__.defaults.baseURL +ret.data)
          }else {
            that.$message.error(ret.msg||"导出异常")
          }
        })
      },
      putHouseNodeExcel(){
        const that=this;
        Http.uploadFile(file=>{
          const loading=that.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          ERP.postRequest({
            url: "admin/ProjectHouse/putHouseNodeExcel",
            data: {
              file:file,
            }
          }, res => {
            loading.close()
            if (res.code) {
              window.location.reload()
            }else {
              that.$message.error(res.msg);
            }
          })
        })
      },
    },
    computed:{

    }
  }
</script>

<style lang="scss">
.el-button--primary,.el-button--success,.el-button--danger {
  color: #FFF;
}
  .tree-win{
    display: flex;
    flex-direction: row;

    .tree-win-left{
      margin-right: 10px;
      border-right: 1px solid #eee;
      padding-right: 10px;
    }
    .tree-win-rigth{
      .tree-win-rigth-header{
        color: #ff3d00;
        padding: 5px 10px;
      }
      .tree-win-rigth-flex{
        display: flex;
        flex-direction: row;
        .tree-win-rigth-content{
          border-radius: 5px;
          border: 1px solid #eaeaea;
          min-width: 400px;
          height: 75vh;
          width: 100%;
          overflow-y: scroll;
          padding: 5px;
          .theme-content-item{
            padding: 4px 10px;
            border-radius: 5px;
            border: 1px solid #d7d7d7;
            cursor: grab;
            min-width: 400px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            line-height: 2;

            &:active{
              cursor: grabbing;
            }
          }
        }
        .tree-win-rigth-flex-msgbox{
          border-radius: 5px;
          border: 1px solid #eaeaea;
          width: 500px;
          height: 75vh;
          padding: 5px;
          margin-left: 10px;
        }
      }
    }
  }

  .fangtai{
    width: 18px;
    height: 18px;
    margin-right: 25px;
    position: relative;
    &::before{
      content: " ";
      position: absolute;
      width: 18px;
      height: 18px;
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;
      background-image: url("../../../assets/image/fangtai/chuzu.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      z-index: 99;
    }
  }
  $icons:chuzu,kongguan,kongzhi,ruzhu,zhuangxiu,tingyong,weiling;
  @each $i in $icons{
    .fangtai_#{$i}{
      &::before{
        background-image: url("../../../assets/image/fangtai/#{$i}.png");
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/ErpTreeUpdateStatus.vue